import React from 'react';
import Icon from 'components/DesignSystem/Icon';
import { SequentialGraphData } from 'types/Meteorology/Agro/WaterBalanceSequential/DetailedView/getGraph';
import { cssVar } from 'constants/theme';
import { useSeriesColor } from 'hooks/theme/useChartTheme';
import ChartDisplay from '../../ChartDisplay';
import './index.scss';

export interface FullscreenChartLegendItem {
  label: string;
  color: string;
  shape: 'bar' | 'line';
}

export default function FullscreenChart({
  open,
  dismiss,
  title,
  legend,
  zoomStart,
  zoomEnd,
  graphData,
  combinedData,
}: {
  open: boolean;
  dismiss: () => void;
  title?: string;
  legend?: FullscreenChartLegendItem[];
  zoomStart: number;
  zoomEnd: number;
  graphData?: SequentialGraphData;
  combinedData?: {
    chuva: SequentialGraphData;
    temperatura: SequentialGraphData;
  };
}) {
  const corSerie = useSeriesColor();
  if (!open) return null;

  return (
    <div className="agro-wbs-dv-fullscreen-overlay">
      <button
        type="button"
        aria-label="Sair do modo tela cheia"
        className="agro-wbs-dv-fullscreen-close"
        onClick={dismiss}
      >
        <Icon iconType="close" color={cssVar('text-strong')} />
      </button>
      <div className="agro-wbs-dv-fullscreen-rotate">
        <div className="agro-wbs-dv-fullscreen-chart">
          <div className="agro-wbs-dv-fullscreen-chart-header">
            <span className="agro-wbs-dv-fullscreen-chart-title">{title}</span>
            {legend && (
              <div className="agro-wbs-dv-fullscreen-chart-legend">
                {legend.map((item) => (
                  <span key={item.label} className="agro-wbs-dv-fullscreen-chart-legend-item">
                    <span
                      className={`agro-wbs-dv-fullscreen-chart-legend-swatch ${item.shape}`}
                      style={{ backgroundColor: corSerie(item.color) }}
                    />
                    {item.label}
                  </span>
                ))}
              </div>
            )}
          </div>
          <div className="agro-wbs-dv-fullscreen-chart-body">
            <ChartDisplay
              zoomStart={zoomStart}
              zoomEnd={zoomEnd}
              height="100%"
              hideTitle
              hideDataZoom
              graphData={graphData}
              combinedData={combinedData}
            />
          </div>
        </div>
      </div>
      <span className="agro-wbs-dv-fullscreen-caption">
        Modo paisagem · toque no X para sair
      </span>
    </div>
  );
}
